import workspaceQuery from 'graphql/queries/purchases/PurchaseRequirementDetailWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/purchases/PurchaseRequirementDetailQuery.graphql';
import mutationQuery from 'graphql/mutations/purchases/PurchaseRequirementDetailMutation.graphql';
import fragment from 'graphql/fragments/purchases/PurchaseRequirementDetailFragment.graphql';

import { workspaceActionsForPermissions } from '../../../actions/purchasing/PurchaseRequirementDetailWorkspaceAction';
import { EntityType } from '../../../@types/entityTypes';

const PurchaseRequirementDetail: EntityType = {
  type: 'PurchaseRequirementDetail',
  title: 'Shortage Details',
  formUrl: '/Purchasing/Shortages/ShortageDetails/Details/',
  formTitle: 'Shortages',
  workspaceUrl: '/Purchasing/Shortages/ShortageDetails/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'SHORTAGES',
  actions: workspaceActionsForPermissions,
};

export default PurchaseRequirementDetail;
